import { api } from "api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

/**
 * Client hook to query for recent appointments, as per the provider's PMS.
 * @param enabled Controls whether or not the query is enabled and actively fetching data.
 * @returns React Query properties.
 */
export function useAppointments(enabled: boolean) {
    return useQuery({
        queryKey: ["appointments"],
        queryFn: async (context) => await api.provider.appointments(context.signal),
        enabled,
        placeholderData: keepPreviousData,
        staleTime: 30000,
        // gcTime intentionally high, for a potentially better experience when upstream service is down
        gcTime: 43200000,
        retry: true,
    });
}
